'use strict'

export function initInScope($scope) {
    const $tooltips = $scope.find('[data-toggle="tooltip"]');
    $tooltips.tooltip()
}